import React, { useEffect, useState } from "react";
import { populateXYaxisBar, formatTimeSeriesData } from "utils/reportUtils";
import { notAllZeros } from "utils/utils";
import PlotlyReport from "./PlotlyReport";
import { valueStrings } from "constants/constantStrings";

const BarChart = ({ report, data, intialLayout, isLoading, error, width, setError }) => {
  const [chartData, setChartData] = useState(null);
  const [layout] = useState({ ...intialLayout, barmode: "group" });

  useEffect(() => {
    if (data && data.Data) {
      let processData = formatTimeSeriesData(data);
      if (processData && processData["Yaxis"] && processData.Time?.length !== 0) {
        let traceData = [];
        let count = 1;
        const yAxisData = processData["Yaxis"];
        for (let i = 0; i < yAxisData.length; i++) {
          if (notAllZeros(processData["Yaxis"][i])) {
            traceData.push(populateXYaxisBar(processData.Time, yAxisData[i], "bar", count));
            count++;
          }
        }
        setChartData(traceData);
      } else {
        report.error = valueStrings.noData;
        setError(valueStrings.noData);
      }
    }
  }, [data]);

  return <PlotlyReport chartData={chartData} layout={layout} isLoading={isLoading} error={error} report={report} width={width} />;
};

export default BarChart;
